import { render, staticRenderFns } from "./customerdetails.vue?vue&type=template&id=49e742a6&"
import script from "./customerdetails.vue?vue&type=script&lang=ts&"
export * from "./customerdetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports